import AddIcon from '@mui/icons-material/Add'
import { Box, CircularProgress, IconButton } from '@mui/material'

import { buttonStylesByMode } from '@helpers'

interface ConfiguredEntityCreateViewRowButtonProps {
  isViewDialogWindow: boolean
  loading: boolean
  onAddEmptyRow: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export const ConfiguredEntityCreateViewRowButton: React.FC<
  ConfiguredEntityCreateViewRowButtonProps
> = props => {
  const { isViewDialogWindow, loading, onAddEmptyRow: handleAddEmptyRow } = props

  return (
    <Box
      sx={theme => ({
        ...buttonStylesByMode(theme, isViewDialogWindow),
        mr: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 20,
        width: 20,
        p: 0,
      })}
    >
      {loading ? (
        <CircularProgress size={14} />
      ) : (
        <IconButton
          size={'medium'}
          sx={theme => ({
            ...buttonStylesByMode(theme, isViewDialogWindow),
            minWidth: 20,
            width: 20,
            p: 0,
          })}
          onClick={handleAddEmptyRow}
        >
          <AddIcon />
        </IconButton>
      )}
    </Box>
  )
}

ConfiguredEntityCreateViewRowButton.displayName = 'ConfiguredEntityCreateViewRowButton'
